import React from "react";
import { IOtherInformationTabProps } from "../../interface";
import NoContentComponent from "@/app/components/ui/EmptyStates/NoContent";

const OtherInformationTab: React.FC<IOtherInformationTabProps> = (_props) => {
  return <NoContentComponent />;
};

export default OtherInformationTab;
